var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onboarding-page send"},[_c('img',{attrs:{"src":require("../../assets/onboarding/send.svg")}}),_c('Guide',{attrs:{"template":_vm.$t('onboarding.send.guide')}},[_c('div',{staticClass:"note",attrs:{"slot":"note"},slot:"note"},[_vm._v(" "+_vm._s(_vm.$t('onboarding.send.note'))+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }